import { render, staticRenderFns } from "./renewal-contact.vue?vue&type=template&id=849f2892&scoped=true&"
import script from "./renewal-contact.vue?vue&type=script&lang=tsx&"
export * from "./renewal-contact.vue?vue&type=script&lang=tsx&"
import style0 from "./renewal-contact.vue?vue&type=style&index=0&id=849f2892&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "849f2892",
  null
  
)

export default component.exports